import { useEffect } from 'react';
import Link from 'next/link';
import { useConfirmDialog } from '@bits/ui/modals/confirm-dialog';

import { useCurrentUser } from '@/lib/hooks/use-current-user';
import {
  setUserPreference,
  useUserPreferences,
} from '@/components/user-preferences/use-user-preferences';

export const GettingStartedDialog = () => {
  const user = useCurrentUser();
  const { data: userPreferences } = useUserPreferences();

  const handleClose = () => {
    setUserPreference('HAS_SEEN_GET_STARTED_POPUP', true);
  };

  const openDialog = useConfirmDialog();
  useEffect(() => {
    if (!user.data?.customerId || userPreferences?.HAS_SEEN_GET_STARTED_POPUP)
      return;

    openDialog({
      title: 'Welcome to Bits Technology',
      size: 'lg',
      onClose: handleClose,
      description: (
        <div className="flex flex-col gap-2">
          <p>
            To get up and running quickly, check out the{' '}
            <strong>Getting Started</strong> guide.
          </p>
          <video
            src="/videos/guides-intro.mp4"
            autoPlay
            muted
            loop
            className="my-2 overflow-hidden rounded-lg"
          />
          <p>You&apos;ll learn how to:</p>
          <ul className="space-y-1 pl-5 [list-style-type:'✓'] [&_li]:pl-2">
            <li>
              Set up your first <strong>Workflow</strong>
            </li>
            <li>
              Configure a <strong>Risk Model</strong>
            </li>
            <li>
              Set up <strong>Monitoring</strong> rules
            </li>
            <li>
              Review and approve your first <strong>Case</strong>
            </li>
          </ul>
          <p>All in just a few simple steps.</p>
        </div>
      ),
      buttons: [
        {
          children: 'No thanks',
          variant: 'secondary',
        },
        {
          asChild: true,
          children: (
            <Link href="/guides/getting-started">
              Yes, take me to the guide
            </Link>
          ),
          variant: 'primary',
        },
      ],
    });
  }, [user?.data?.customerId]);

  return null;
};
